import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-sm text-zinc-500" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Only owners have admin-panel access in the new role model.
  const levels = { admin: 1, owner: 2 };
  if (requireRole && (levels[user.role] || 0) < (levels[requireRole] || 0)) {
    return <Navigate to="/inbox" replace />;
  }
  return children;
}
